import { render, staticRenderFns } from "./books.vue?vue&type=template&id=c6c565d4"
import script from "./books.ts?vue&type=script&lang=js&external"
export * from "./books.ts?vue&type=script&lang=js&external"
import style0 from "./books.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports